import { isImageXData, isVectorImageData, isWPhotoData, isBackgroundMedia, isBuilderImageData, isBuilderImageContainer, isBuilderVectorArtData, isBuilderVectorArtContainer, isFastGalleryData } from '../../data-extractor/components-type-guards';
import { assertNotOptional } from '@wix/seo-common-core';
export function updateImageProperties(component, _ref) {
  let {
    alt,
    decorative,
    builderLabel
  } = _ref;
  const {
    data,
    design,
    type
  } = component;
  const updatedData = data ? {
    ...data
  } : undefined;
  let updatedDesign = design ? {
    ...design
  } : undefined;
  if (isImageXData(updatedData)) {
    updatedData.image.alt = alt;
    updatedData.image.decorative = decorative;
  } else if (isWPhotoData(updatedData) || isVectorImageData(updatedData)) {
    updatedData.alt = alt;
    updatedData.decorative = decorative;
  } else if (isBackgroundMedia(updatedDesign)) {
    updatedDesign = handleBackgroundMedia(updatedDesign, alt, decorative);
  } else if (builderLabel && isBuilderImageContainer(updatedData)) {
    const imageData = updatedData[builderLabel];
    if (isBuilderImageData(imageData)) {
      imageData.alt = decorative ? null : alt;
    }
  } else if (builderLabel && isBuilderVectorArtContainer(updatedData)) {
    const vectorArtData = updatedData[builderLabel];
    if (isBuilderVectorArtData(vectorArtData)) {
      if (!updatedData.a11y) {
        updatedData.a11y = {};
      }
      updatedData.a11y.ariaHidden = decorative;
    }
  } else {
    throw new Error(`Unknown image component type: ${type}`);
  }
  const updatedComponent = {
    ...component
  };
  if (updatedData) {
    updatedComponent.data = updatedData;
  }
  if (updatedDesign) {
    updatedComponent.design = updatedDesign;
  }
  return updatedComponent;
}
export function updateMultipleImageProperties(component, _ref2) {
  let {
    images
  } = _ref2;
  const {
    data,
    design,
    type
  } = component;
  const updatedData = data ? {
    ...data
  } : undefined;
  const updatedDesign = design ? {
    ...design
  } : undefined;
  if (isFastGalleryData(component) && updatedData) {
    // update the alt text for the images in the fast gallery
    const items = updatedData.items;
    if (Array.isArray(items)) {
      // Create a map of items by imageId for O(1) lookup
      // imageInfo uses `altText`, imageData uses `alt` (enforced by editor schema)
      const itemsByImageId = new Map();
      for (const item of items) {
        var _item$media, _item$media2;
        const imageInfo = item == null || (_item$media = item.media) == null || (_item$media = _item$media.imageOptions) == null ? void 0 : _item$media.imageInfo;
        const imageData = item == null || (_item$media2 = item.media) == null || (_item$media2 = _item$media2.imageOptions) == null ? void 0 : _item$media2.imageData;
        const resolved = imageInfo ?? imageData;
        if (resolved && typeof resolved === 'object' && resolved.id) {
          itemsByImageId.set(resolved.id, {
            ref: resolved,
            isImageDataPath: !imageInfo && !!imageData
          });
        }
      }

      // Iterate through the given images (smaller array) and update matching items
      for (const image of images) {
        // The images array may have imageId property (extended ImageObject)
        const imageId = image.imageId ?? image.id;
        if (!imageId) {
          continue;
        }
        const entry = itemsByImageId.get(imageId);
        if (entry) {
          if (entry.isImageDataPath) {
            entry.ref.alt = image.alt;
          } else {
            entry.ref.altText = image.alt;
          }
        }
      }
    }
  } else {
    throw new Error(`Unknown image component type: ${type}`);
  }
  const updatedComponent = {
    ...component
  };
  if (updatedData) {
    updatedComponent.data = updatedData;
  }
  if (updatedDesign) {
    updatedComponent.design = updatedDesign;
  }
  return updatedComponent;
}
function handleBackgroundMedia(design, alt, decorative) {
  assertNotOptional(design.background, 'background');
  const background = design.background;
  if ('mediaRef' in background) {
    if (background.mediaRef.type === 'Image') {
      background.mediaRef.alt = alt;
      background.mediaRef.decorative = decorative;
      return design;
    }
  }
  throw new Error('Cannot update background media properties - unknown design structure');
}
//# sourceMappingURL=update-image-properties.js.map